export const ROOT_FOLDER =
  typeof process.env.REACT_APP_ROOT_FOLDER === 'string'
    ? process.env.REACT_APP_ROOT_FOLDER
    : '/v2';

export const PAGES = {
  DASHBOARD: 'dashboard',
  QI: 'underwriting-qi',
  APPLICATION: 'application',
  CLIENT_DETAILS: 'client-details',
  QUOTE: 'quote',
  CONTACT_DETAILS: 'contact-details',
  UNDERWRITING: 'application',
  AMRA: 'amra',
  DECISION: 'decision',
  SET_UP: 'set-up',
  REVIEW: 'review',
  COMPLETE: 'complete',
  POLICY_HOLDER: 'policy-holder',
  POLICY_HOLDERS: 'policy-holders',
  PORTAL_ERROR: 'error',
  PORTAL_LANDING: 'portal',
  PORTAL_REDIRECT: 'portal-redirect',
  QI_CLIENT_DETAILS: 'client-details',
  ERROR: 'service-error',
};

export const ROUTES = {
  DASHBOARD: `${ROOT_FOLDER}/${PAGES.DASHBOARD}`,
  QI: `${ROOT_FOLDER}/${PAGES.QI}`,
  APPLICATION: `${ROOT_FOLDER}/${PAGES.APPLICATION}/:applicationId*`,
  CLIENT_DETAILS: `${ROOT_FOLDER}/${PAGES.APPLICATION}/:applicationId/${PAGES.CLIENT_DETAILS}`,
  QUOTE: `${ROOT_FOLDER}/${PAGES.APPLICATION}/:applicationId/${PAGES.QUOTE}`,
  CONTACT_DETAILS: `${ROOT_FOLDER}/${PAGES.APPLICATION}/:applicationId/${PAGES.CONTACT_DETAILS}`,
  UNDERWRITING: `${ROOT_FOLDER}/${PAGES.APPLICATION}/:applicationId/${PAGES.UNDERWRITING}`,
  AMRA: `${ROOT_FOLDER}/${PAGES.APPLICATION}/:applicationId/${PAGES.AMRA}`,
  DECISION: `${ROOT_FOLDER}/${PAGES.APPLICATION}/:applicationId/${PAGES.DECISION}`,
  SET_UP: `${ROOT_FOLDER}/${PAGES.APPLICATION}/:applicationId/${PAGES.SET_UP}`,
  REVIEW: `${ROOT_FOLDER}/${PAGES.APPLICATION}/:applicationId/${PAGES.REVIEW}`,
  COMPLETE: `${ROOT_FOLDER}/${PAGES.APPLICATION}/:applicationId/${PAGES.COMPLETE}`,
  POLICY_HOLDER: `${ROOT_FOLDER}/${PAGES.POLICY_HOLDER}/:policyHolderId`,
  PORTAL_REDIRECT: `${ROOT_FOLDER}/${PAGES.PORTAL_REDIRECT}`,
  PORTAL_LANDING: `${ROOT_FOLDER}/${PAGES.PORTAL_LANDING}`,
  PORTAL_ERROR: `${ROOT_FOLDER}/${PAGES.PORTAL_ERROR}`,
  ERROR: `${ROOT_FOLDER}/${PAGES.ERROR}`,
  LOGOUT: `${ROOT_FOLDER}/logout`,
};

export const QI_PAGES = {
  CLIENT_DETAILS: 'client-details',
  CONDITIONS: 'conditions',
  DECISION: 'decision',
};

export const QI_ROUTES = {
  CLIENT_DETAILS: `${ROOT_FOLDER}/${PAGES.QI}/${QI_PAGES.CLIENT_DETAILS}`,
  CONDITIONS: `${ROOT_FOLDER}/${PAGES.QI}/${QI_PAGES.CONDITIONS}`,
  DECISION: `${ROOT_FOLDER}/${PAGES.QI}/${QI_PAGES.DECISION}`,
};

export const NBJ1_APPLICATION_LAUNCH_PAGE = `/launch`;
